import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import * as styles from './gold-silver.module.scss'
import BlankBanner from '../../components/banners/blankBanner/BlankBanner'
import ContentWithStickyColumn from '../../components/content-with-sticky-column/ContentWithStickyColumn'
import RequestAccess from '../../components/request-access/RequestAccess'
import SEOControl from '../../components/seoControl/seoControl'
import StoresBlock from '../../components/storesBlock/StoresBlock'
import LinkWithIcon from '../../components/ui/buttons/link-with-icon/LinkWithIcon'
import ROUTES from '../../constants/routes'

const TITLE = 'Buy Gold With Super | Gold & Silver SMSF Investing - Bamboo'
const DESCRIPTION =
  'Looking to buy & invest in Gold & Silver using your SMSF or spare change? Bamboo is a smart investing app that will get you started. Download the app today!'
const KEYWORDS =
  'bamboo, blockchain, gold, silver, precious metals, bitcoin, ethereum, digital assets, litecoin, crypto, buy, invest, invest today, micro investment, microinvestment, micro-investment, solvency protocol, proof of solvency, spare change, budget'

function GoldSilverPage({ location }) {
  const heading = (
    <>
      {location?.state?.prevLocation && (
        <LinkWithIcon
          to={location.state.prevLocation}
          className={styles.link}
          isReversed
        >
          back to {location?.state?.prevPageName || 'page'}
        </LinkWithIcon>
      )}
      <h2 className={styles.infoTitle}>Gold and Silver Standard</h2>
      <div className={styles.imgWrapper}>
        <StaticImage
          className={styles.imgItem}
          src="../../assets/images/3D_images/Dollar_gold.png"
          alt="Bamboo investments App"
          width={400}
          height={400}
        />
        <StaticImage
          className={styles.imgItem}
          src="../../assets/images/3D_images/Dollar_silver.png"
          alt="Bamboo investments App"
          width={400}
          height={400}
        />
      </div>
      <p className={styles.infoText}>
        Gold and Silver Standard are two of the world’s most time-tested
        precious metals investment options..
      </p>
    </>
  )

  return (
    <>
      <SEOControl title={TITLE} description={DESCRIPTION} keywords={KEYWORDS} />

      <BlankBanner />

      <ContentWithStickyColumn
        info={heading}
        title="Invest your SMSF in Gold & Silver"
      >
        <div className={styles.content}>
          <h2>
            Gold and Silver Standard are our time-tested precious metal
            investment options. In partnership with Ainslie Wealth, we’re able
            to offer our users access to these high performing currencies.
          </h2>
          <br />
          <br />
          <h3>Why Gold and Silver?</h3>
          <br />
          <p>
            Precious metals have long been used as alternative stores of value
            by people looking to diversify their investment portfolio. Gold and
            Silver Standard have traditionally been viewed as a safe haven to
            shelter wealth during periods of economic uncertainty.
          </p>
          <br />
          <p>
            When people refer to the Blockchain, this is a technology
            introducing cryptography to the mix and collating data into blocks.
            Each encrypted block is stored on the chain in chronological order,
            after which no more changes can be made.
          </p>
          <br />
          <p>
            Global political and economic turmoil in recent decades has prompted
            increased accumulation of these precious metals by institutions such
            as central banks. The greater demand and resulting price support
            have seen the price of these precious metals rise by nearly 15%
            since the start of 2019, with Gold Standard hitting a 6-year high.
          </p>
          <br />
          <p>
            Whether you are looking to invest in Gold and Silver Standard using
            your <Link to={ROUTES.SMSF}>Self-Managed Super Fund (SMSF)</Link> or
            just looking to make your spare change work for you, Bamboo makes
            the process easy. The option of adding Gold and Silver Standard to
            your investment portfolio is as simple as navigating to the new
            portfolio page and choosing either a pre-set portfolio or creating
            your own. You can select as little as 1% of your portfolio to an
            asset class, which is a great way to dip your toes into new markets.
          </p>
          <br />
          <p>
            Each Gold and Silver Standard token purchased on the platform
            represents one gram of real-world Gold and Silver. These real-world
            assets are stored securely by Ainslie Wealth in the Reserve Vault,
            one of the most secure underground storage facilities in the
            Southern Hemisphere. Gold and Silver Standard undergo regular audits
            by reputable assurance firm, BDO, assessing their security,
            accuracy, and purity.
          </p>
          <br />
          <h3>Start investing in Gold & Silver with Bamboo</h3>
          <br />
          <p>
            Sign up to effortless investing and make your Self-Managed Super
            Fund go further. Get set up in minutes and start investing in Gold
            and Silver Standard with confidence. Your future self thanks you! If
            you need assistance, reach out to our{' '}
            <Link to={ROUTES.SUPPORT}>support</Link> team today.
          </p>
          <StoresBlock className={styles.stores} />
        </div>
      </ContentWithStickyColumn>

      <RequestAccess />
    </>
  )
}

export default GoldSilverPage
